import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
// config
import { APP_CONFIG, Config } from './core/config';

// ngx-translate
import {TranslateModule, TranslateLoader, TranslatePipe} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

// interceptor
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalInterceptor } from './core/global.interceptor';

// cookie
import { CookieService } from 'ngx-cookie-service';

// COMPOSITION_BUFFER_MODE import
import { COMPOSITION_BUFFER_MODE } from '@angular/forms';


// components
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/layouts/header/header.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { IndexComponent } from './components/index/index.component';
import { GlobalModule } from './global.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutComponent } from 'src/app/components/layouts/layout.component';
import { FormsModule } from '@angular/forms';
import { Restore } from './services/restore';

@NgModule({
    declarations: [
        AppComponent,
        LayoutComponent,
        HeaderComponent,
        FooterComponent,
        IndexComponent , 
        
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        GlobalModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        
        FormsModule,
        BrowserAnimationsModule,
      

    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlobalInterceptor,
            multi: true
        },
        {
            provide: Config,
            useValue: APP_CONFIG
        }
        ,
        CookieService, Title, Restore,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
